<template>
  <div>
    <Index/>
  </div>
</template>

<script>
import Index from './Index.vue'


export default {
  name: 'Home',
  components: {
    Index
  }
}
</script>
